module.exports = __webpack_public_path__ + "img/22.3ad15961.jpg";